import { render } from "./QueryListView.vue?vue&type=template&id=523993ec"
import script from "./QueryListView.vue?vue&type=script&lang=js"
export * from "./QueryListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__